module.exports = __webpack_public_path__ + "img/clownpiece.20070114.png";